import { Entity, SoftLink } from "@cayo/shared/api/types/cayo-graph";
import { bindingsRegexes } from "@cayo/shared/scheme/bindings/regexes";

export const oDataTypes = {
  softLink: "#cayo.graph.softLink",
};

const entityToSoftLink = (entity: Entity): SoftLink => {
  return {
    "@odata.type": oDataTypes.softLink,
    id: entity.id,
    objectType: entity.objectType,
    objectName: entity.objectName,
    objectPath: entity.objectPath,
    linkType: entity.linkType || entity.objectType,
    displayName: (entity as any).displayName,
  } as any;
};

const objectToPickerValue = (
  o: any,
  model: any,
  displayNameProp?: string,
  displayNameAlternateProp?: string
) => {
  const result: any = {};
  Object.keys(o).forEach((k) => {
    const r = bindingsRegexes.insideCurlyBrackets.exec(o[k]);
    if (r) {
      const propName = r[1];
      result[k] = model[propName] || model[k];

      if (
        !result[k] &&
        displayNameProp &&
        k.toLocaleLowerCase() === displayNameProp.toLocaleLowerCase()
      ) {
        result[k] = model[displayNameProp!] || model[displayNameAlternateProp!];
      }
    }
  });

  return result;
};

const oDataConverters = {
  entityToSoftLink,
  objectToPickerValue,
};

export default oDataConverters;
